import { CREDITS_ENABLED } from "@/config/features";
import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { useCredits } from "@/hooks/useCredits";
import { useAuth } from "@/hooks/useAuth";

/**
 * Sticky red ribbon shown when the signed-in user has 0 credits.
 * AI features will fail server-side (consume_credits returns 402); this
 * surfaces that state at the top of every page.
 */
export function CreditEmptyBanner() {
  const { user } = useAuth();
  const { total, loading, summary } = useCredits();
  if (!CREDITS_ENABLED) return null;
  if (!user || loading || !summary) return null;
  if (total > 0) return null;

  return (
    <div className="w-full bg-primary/10 text-foreground px-3 py-1.5 text-xs sm:text-sm flex items-center justify-center gap-2 border-b border-primary/30">
      <Heart className="w-4 h-4 shrink-0 text-primary fill-primary" />
      <span className="font-medium">Your credits ran out — no rush, just refill whenever you're ready.</span>
      <Link
        to="/credits"
        className="ml-1 underline font-semibold text-primary hover:no-underline"
      >
        Refill
      </Link>
    </div>
  );
}
